export default __webpack_public_path__ + "static/media/about_main.5502e968.mp4";